import { useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { List, ListItem, Typography, Button, Dialog, DialogActions, DialogContent, TextField, DialogTitle, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useGetProfileQuery } from '../features/api/rest/apiProfileSlice';
import { useUpdateQuestionMutation, useDeleteQuestionMutation } from '../features/api/rest/apiQuestionsSlice';
import CheckAnswers from './CheckAnswers';
import Spinner from './Spinner';
import VotingArrow from './VotingArrow';
import QuestionReport from './QuestionReport';

function QuestionCard({ id, owner, question, totScore }) {
  const { ean } = useParams();
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [questionToHandle, setQuestionToHandle] = useState(question);

  const { currentData, status } = useGetProfileQuery(undefined, { refetchOnMountOrArgChange: true });

  const [updateQuestion, { isLoadingUpload }] = useUpdateQuestionMutation();
  const [deleteQuestion, { isLoadingDelete }] = useDeleteQuestionMutation();

  const handleQuestionClick = () => {
    setOpen(!open);
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    try {
      await updateQuestion({ payload: { body: questionToHandle }, ean, id }).unwrap();
      setQuestionToHandle('');
      setOpen(false);
      window.location.reload();
    } catch (err) {
      console.error(err); // todo: check err.status and provide feedback to the user
    }
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    try {
      await deleteQuestion({ ean, id }).unwrap();
      window.location.reload();
    } catch (err) {
      console.error(err); // todo: check err.status and provide feedback to the user
    }
  };

  if (isLoadingDelete || isLoadingUpload) return <Spinner />;

  return (
    <List sx={{ border: 'none', pb: 0, pt: 0 }}>
      <ListItem>
        <VotingArrow questionId={id} totScore={totScore} typology="Question" />
        <Box sx={{ height: '100%' }}>
          <Typography sx={{ ml: 1, fontSize: 17, fontWeight: 'bold' }}>{question}</Typography>
          {status === 'fulfilled' && owner === currentData.username && <Button onClick={handleQuestionClick}>{t('questionsAnswers.handleQuestion')}</Button>}
          <QuestionReport questionId={id} owner={owner} />
        </Box>
      </ListItem>
      <Dialog open={open} onClose={handleQuestionClick} fullWidth maxWidth="sm">
        <DialogTitle>{t('questionsAnswers.handleQuestionTitle')}</DialogTitle>
        <DialogContent>
          <TextField autoFocus margin="dense" id="question" type="text" fullWidth variant="standard" required value={questionToHandle} onChange={(e) => setQuestionToHandle(e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleQuestionClick}>{t('common.actions.cancel')}</Button>
          <Button onClick={handleDelete}>{t('common.actions.delete')}</Button>
          <Button onClick={handleEdit}>{t('common.actions.edit')}</Button>
        </DialogActions>
      </Dialog>
      <CheckAnswers id={id} owner={owner} />
    </List>
  );
}

QuestionCard.propTypes = {
  id: PropTypes.number.isRequired,
  owner: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  totScore: PropTypes.number.isRequired,
};

export default QuestionCard;
